import { OrderSide } from '@shared-types';

/** Trade value (ارزش معامله) including commission. */
export function calculateTradeValue(
	side: OrderSide,
	price: number,
	quantity: number,
	buyCommissionRate: number,
	sellCommissionRate: number
): number {
	if (!price || !quantity) {
		return 0;
	}

	if (side === OrderSide.Buy) {
		return Math.round(price * quantity * (1 + buyCommissionRate));
	}

	return Math.round(price * quantity * (1 - sellCommissionRate));
}

/** Commission amount (مبلغ کارمزد). */
export function calculateCommissionValue(
	side: OrderSide,
	price: number,
	quantity: number,
	buyCommissionRate: number,
	sellCommissionRate: number
): number {
	if (!price || !quantity) {
		return 0;
	}

	const rate = side === OrderSide.Buy ? buyCommissionRate : sellCommissionRate;
	return Math.round(price * quantity * rate);
}

/**
 * Breakeven price (قیمت سربه سر).
 * Buy: always from entered price.
 * Sell: only when user has assets; uses average buy price.
 */
export function calculateBreakevenPrice(
	side: OrderSide,
	enteredPrice: number,
	averageBuyPrice: number,
	currentAsset: number,
	buyCommissionRate: number,
	sellCommissionRate: number
): number | null {
	if (side === OrderSide.Buy) {
		if (!enteredPrice) {
			return 0;
		}
		return Math.round(enteredPrice * ((1 + buyCommissionRate) / (1 - sellCommissionRate)));
	}

	if (currentAsset <= 0 || !averageBuyPrice) {
		return null;
	}

	return Math.round(averageBuyPrice / (1 - sellCommissionRate));
}
